<template>
<section class="progress-outer">
    <!--Begin Progress section-->
    <ul>
        <li><button @click.prevent="clickTab(1)" class="active">Add funds</button></li>
        <!--<li><a href="#" @click="clickTab(2)" :class="{ active: currentStep>1 }">Review &amp; Place Order</a></li>-->
        <li><button @click.prevent="clickTab(2)" :class="{ active: currentStep>1 }">Confirmation</button></li>
    </ul>
    <!--End Progress section-->
</section>

</template>
<script>
export default {
    props:{
        currentStep:{
            required:true,
        }
    },
    methods:{
        clickTab(step){
            kinfEvents.$emit('ClickTabStep',step);
        }
    }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// resources/js/views/checkout/components/index/TabsCheckout.vue